import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import { useMemo } from 'react'
import { NOTIFICATION_TARGET_ORGANIZATION, NOTIFICATION_TARGET_USER } from '@constants/realtime'
import SendDemoNotificationForm from '$routes/KitchenSink/widgets/SendDemoNotificationForm'

const KSRealtime = () => {
    
    const remoteConfig = useWireValue(store.remoteConfig)
    const userPresenceCount = useWireValue(store.realtimeUserPresenceCount)
    const organizationPresenceCount = useWireValue(store.realtimeOrganizationPresenceCount)
    const notifications = useWireValue(store.notifications)
    
    const userNotifications = useMemo(() => (
        notifications.filter(it => it.message.data.target === NOTIFICATION_TARGET_USER)
    ), [notifications])
    
    const organizationNotifications = useMemo(() => (
        notifications.filter(it => it.message.data.target === NOTIFICATION_TARGET_ORGANIZATION)
    ), [notifications])
    
    return (
        
        <div id="KSRealtime" className="p-3 pt-0">
            
            {!remoteConfig?.realtimeEnabled && (
                <div className="alert alert-warning my-3">
                    Realtime is not enabled in your environment!
                </div>
            )}
            
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 mt-8 pt-2 border-t border-gray-700">
                
                <div>
                    <header className="mb-2 p-3 rounded bg-base-200">
                        <h5 className="text-xl">Demo Actions</h5>
                    </header>
                    <div className="card bg-base-200 w-96 shadow-xl">
                        <h5 className="px-4 py-3">Send Demo Notification</h5>
                        <div className="card-body p-3">
                            <SendDemoNotificationForm/>
                        </div>
                        {/* @todo update existing notification form & dismiss notification form */}
                    </div>
                </div>
                
                <div>
                    <header className="mb-2 p-3 rounded bg-base-200">
                        <h5 className="text-xl">User Presence: {userPresenceCount}</h5>
                        <h5 className="text-xl">User Notifications</h5>
                    </header>
                    <ul>
                        {!userNotifications.length && <li>No notifications</li>}
                        {userNotifications.map(it => (
                            <li key={it.message.id}>
                                <pre><code>{JSON.stringify(it.message, null, 4)}</code></pre>
                            </li>
                        ))}
                    </ul>
                </div>
                
                <div>
                    <header className="mb-2 p-3 rounded bg-base-200">
                        <h5 className="text-xl">Organization Presence: {organizationPresenceCount}</h5>
                        <h5 className="text-xl">Organization Notifications</h5>
                    </header>
                    <ul>
                        {!organizationNotifications.length && <li>No notifications</li>}
                        {organizationNotifications.map(it => (
                            <li key={it.message.id}>
                                <pre><code>{JSON.stringify(it.message, null, 4)}</code></pre>
                            </li>
                        ))}
                    </ul>
                </div>
            
            </div>
        
        </div>
        
    )
    
}

export default KSRealtime
